import logoUrl from "../assets/skr-logo.svg";

export default function MobileTopBar({ onOpenNav }: { onOpenNav: () => void }) {
  return (
    <div className="mobile-topbar">
      <button
        className="mobile-hamburger"
        onClick={onOpenNav}
        aria-label="Open navigation"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <line x1="3" y1="6"  x2="21" y2="6"/>
          <line x1="3" y1="12" x2="21" y2="12"/>
          <line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      </button>
      <img src={logoUrl} alt="SKR Law" style={{ maxHeight: 40, maxWidth: 160, objectFit: "contain" }} />
      <div style={{ width: 38 }} /> {/* spacer to center the logo */}
    </div>
  );
}
